module.exports = __webpack_public_path__ + "static/media/05.192c32cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/05.jpg
// module id = 464
// module chunks = 0